export default __webpack_public_path__ + "static/media/stefan-contact-image.b94ef1ae.png";